module.exports = __webpack_public_path__ + "img/HQ-ENC-H-V1_ALL.c9de7bd0.jpg";